import { authHeader } from "../_helpers";
import config from "../config";
import { handleResponse } from "./common/handle-response";

export const teamService = {
    getAll,
    create,
    remove,
    uploadLogo,
    updateTeamOrder 
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${config.apiUrl}/teams`, requestOptions).then(handleResponse);
}

function create(form) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeader() },
        body: JSON.stringify(form)
    };

    return fetch(`${config.apiUrl}/teams`, requestOptions).then(handleResponse);
}

function updateTeamOrder(form) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeader() },
        body: JSON.stringify(form)
    };

    return fetch(`${config.apiUrl}/teams/update-order`, requestOptions).then(handleResponse);
} 

function remove(teamId) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeader() },
    };

    return fetch(`${config.apiUrl}/teams/${teamId}/remove`, requestOptions).then(handleResponse);
}

function uploadLogo(file) {
    const formData = new FormData();
    formData.append('File', file);

    const requestOptions = {
        method: 'PUT',
        headers: {
            ...authHeader()
           
        },
        body: formData
    };

    return fetch(`${config.apiUrl}/media`, requestOptions).then(handleResponse);
}
